import React from 'react';
import image from '../../../static/images/mail.svg';

interface DataContext {
  drupalData: Queries.paragraph__confirmation;
}

export default function Confirmation({drupalData}: DataContext): React.JSX.Element {
  return (
    <section className="vl-region">
      <div className="vl-layout vl-u-align-center">
        <img src={image} alt="mail" style={{
          'width': '50%',
          'padding-right': '16%'
        }}/>
        <h3 className="vl-title vl-title--h3" style={{'margin-top': '3rem'}}>{drupalData.field_title}</h3>
        <p>{drupalData.field_description}</p>
      </div>
    </section>
  );
}
